module.exports = __webpack_public_path__ + "static/img/006.bd2c760.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/factory/006.jpg
// module id = lLtV
// module chunks = 1